<!-- 侧边栏菜单item license by http://eleadmin.com -->
<template>
  <el-submenu
    v-if="haveChildren"
    :index="item.path"
    :popper-class="firstPopClass || popClass"
    :popper-append-to-body="popperAppendToBody"
  >
    <template slot="title">
      <i v-if="item.meta.icon" :class="item.meta.icon"></i>
      <span slot="title">{{ item.meta.title }}</span>
    </template>
    <template v-for="child in item.children">
      <ele-pro-sidebar-item
        v-if="!child.meta.hide"
        :key="child.path"
        :item="child"
        :pop-class="popClass"
        :with-tooltip="false"
      />
    </template>
  </el-submenu>
  <el-menu-item v-else-if="withTooltip" :index="item.path">
    <el-tooltip
      placement="right"
      :content="item.meta.title"
      :disabled="tooltipDisabled || !collapse"
    >
      <a v-if="isUrl" :href="item.path" target="_blank" @click.stop="">
        <i v-if="item.meta.icon" :class="item.meta.icon"></i>
        <span>{{ item.meta.title }}</span>
      </a>
      <router-link v-else :to="item.path">
        <i v-if="item.meta.icon" :class="item.meta.icon"></i>
        <span>{{ item.meta.title }}</span>
      </router-link>
    </el-tooltip>
  </el-menu-item>
  <el-menu-item v-else :index="item.path">
    <a v-if="isUrl" :href="item.path" target="_blank" @click.stop="">
      <i v-if="item.meta.icon" :class="item.meta.icon"></i>
      <span>{{ item.meta.title }}</span>
    </a>
    <router-link v-else :to="item.path">
      <i v-if="item.meta.icon" :class="item.meta.icon"></i>
      <span>{{ item.meta.title }}</span>
    </router-link>
  </el-menu-item>
</template>

<script>
  import { isUrl } from '../../../utils/index.js';

  export default {
    name: 'EleProSidebarItem',
    props: {
      // 菜单item数据
      item: {
        type: Object,
        required: true
      },
      // pop菜单class
      popClass: String,
      // 一级pop菜单class
      firstPopClass: String,
      // 是否将弹出菜单插入至 body 元素
      popperAppendToBody: {
        type: Boolean,
        default: false
      },
      // 是否折叠
      collapse: Boolean,
      // 是否增加tooltip
      withTooltip: {
        type: Boolean,
        default: true
      },
      // 是否禁用tooltip
      tooltipDisabled: Boolean
    },
    computed: {
      /* 是否有子级 */
      haveChildren() {
        return !!(
          this.item.children &&
          this.item.children.filter((d) => !d.meta.hide).length
        );
      },
      /* 是否是网址 */
      isUrl() {
        return isUrl(this.item.path);
      }
    }
  };
</script>
